import { datadogLogs } from '@datadog/browser-logs'
import '@mdi/font/css/materialdesignicons.css'
import 'jquery'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import router from 'src/router'
import store from 'store'
import { SPINNER_TYPES } from 'store/types'
import money from 'v-money'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import JsonEditor from 'vue-json-editor'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { mapActions, mapGetters } from 'vuex'
import { sync } from 'vuex-router-sync'
import AUTH_TYPES from './modules/auth/store/types'
import './style.scss'
import {
  NOTIFY,
  NOTIFY_ERROR,
  NOTIFY_SUCCESS,
  NOTIFY_WARNING
} from './vuex/modules/snackbar/types'

// Override babel-runtime promise with Bluebird
require('babel-runtime/core-js/promise').default = require('bluebird')

// Promise.allSettled polyfill
window.promiseAllSettled = (promises) => {
  let wrappedPromises = promises.map((p) =>
    Promise.resolve(p).then(
      (val) => ({ status: 'fulfilled', value: val }),
      (err) => ({ status: 'rejected', reason: err })
    )
  )

  return Promise.all(wrappedPromises)
}

const vuetifyOpts = {
  // icons: {
  iconfont: ['mdi', 'fa4'],
  // },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        secondary: '#646464',
        accent: '#3C8DBC',
        accentHover: '#0070C0',
        accent15: '#E2EEF5',
        info: '#17A2B8',
        infoHover: '#117A8B',
        warning: '#FF9800',
        warningHover: '#CC7A00',
        lightWarning: '#FFF3E0',
        error: '#DC3545',
        dark: '#343A40',
        success: '#28A745',
        successHover: '#1E7E34',
        black: '#040404',
        disabledGrey: '#E0E0E0',
        lightGrey: '#F0F0F0',
        neutral: '#F8F9FA',
        greenMedium: '#00B050',
        disabledMediumGrey: '#AEAEAE',
        grey: '#505050',
        neutralGray: '#0F172A',
        brand: '#1E2251'
      }
    }
  }
}

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(JsonEditor)
Vue.use(money)
Vue.use(Vuetify)
Vue.config.debug = process.env.NODE_ENV !== 'production'
Vue.config.productionTip = false

sync(store, router)

Vue.mixin({
  methods: {
    ...mapActions({
      showSpinner: SPINNER_TYPES.SPINNER.SHOW,
      hideSpinner: SPINNER_TYPES.SPINNER.HIDE,
      notifySuccess: NOTIFY_SUCCESS,
      notifyError: NOTIFY_ERROR,
      notifyWarning: NOTIFY_WARNING,
      notify: NOTIFY
    })
  }
})

if (
  process.env.NODE_ENV === 'production' ||
  process.env.NODE_ENV === 'staging'
) {
  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    env: ENV,
    forwardErrorsToLogs: true,
    service: 'pivot-backoffice',
    sessionSampleRate: 100,
    site: DATADOG_SITE
  })
}

const App = new Vue({
  name: 'Root',
  el: '#root',
  template: '<v-app><router-view/></v-app>',
  vuetify: new Vuetify(vuetifyOpts),
  computed: {
    ...mapGetters({
      isAuthenticated: store.getters[AUTH_TYPES.GET_TOKEN]
    })
  },
  router,
  store
})

export default App
